import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Section';
import { deepQuotes } from '../data/content';
export function Testimonials() {
  return <Section tone="white" eyebrow="Testimonios" title="Historias reales de impacto" data-id="element-169" data-mp="3ksqgpam7bm8l">
      <ul className="mx-auto max-w-narrow divide-y divide-gray-200" data-id="element-170" data-mp="3fxkusbssu7ki">
        {deepQuotes.map(quote => <li key={quote.author} className="grid gap-4 py-8 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,14rem)_1fr] md:gap-10" data-id="element-171" data-mp="3ayqcrc2non1g">
            <div className="flex items-start gap-3" data-id="element-172" data-mp="31z37ugapwz3n">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-plum-700 font-display text-xs font-bold text-rose-100" data-id="element-173" data-mp="2x0jn2j7v1tcv">
                {quote.initials}
              </span>
              <span data-id="element-174" data-mp="v9yh9eyp81bu">
                <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-175" data-mp="v8dmppcdwidz">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-176" data-mp="q8ivfkop5qse" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-display font-extrabold tracking-tight text-ink" data-id="element-177" data-mp="78k3jb88caqm">
                  {quote.author}
                </span>
                <span className="block text-sm text-gray-500" data-id="element-178" data-mp="c8oll5osddiy">{quote.role}</span>
              </span>
            </div>
            <blockquote className="border-l-4 border-rose-500 pl-5 text-lg leading-relaxed text-ink md:text-xl" data-id="element-179" data-mp="14vj07lyx9ioi">
              “{quote.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}